import { render, staticRenderFns } from "./PreventiveHealthAndVaccination.vue?vue&type=template&id=09927d25&"
import script from "./PreventiveHealthAndVaccination.vue?vue&type=script&lang=js&"
export * from "./PreventiveHealthAndVaccination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports